// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceKindEnum } from './DeviceKindEnum';
import { deviceStatusEnum } from './DeviceStatusEnum';
import { operatorId } from './Operator';
import { deviceModelId } from './DeviceModel';
import { z } from 'zod';
export const deviceId = (z.number());
export const device = z.object({
    id: deviceId,
    hardware_id: z.string(),
    kind: deviceKindEnum,
    name: z.string().nullable(),
    unit: z.string().nullable(),
    firmware_version: z.string().nullable(),
    manifest_raw: z.unknown().nullable(),
    status: deviceStatusEnum,
    last_seen_at: z.date().nullable(),
    gateway_address: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    device_model_id: deviceModelId.nullable(),
    archived_at: z.date().nullable(),
    archived_by: operatorId.nullable(),
});
export const deviceInitializer = z.object({
    id: deviceId.optional(),
    hardware_id: z.string(),
    kind: deviceKindEnum,
    name: z.string().optional().nullable(),
    unit: z.string().optional().nullable(),
    firmware_version: z.string().optional().nullable(),
    manifest_raw: z.unknown().optional().nullable(),
    status: deviceStatusEnum.optional(),
    last_seen_at: z.date().optional().nullable(),
    gateway_address: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    device_model_id: deviceModelId.optional().nullable(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
});
export const deviceMutator = z.object({
    id: deviceId.optional(),
    hardware_id: z.string().optional(),
    kind: deviceKindEnum.optional(),
    name: z.string().optional().nullable(),
    unit: z.string().optional().nullable(),
    firmware_version: z.string().optional().nullable(),
    manifest_raw: z.unknown().optional().nullable(),
    status: deviceStatusEnum.optional(),
    last_seen_at: z.date().optional().nullable(),
    gateway_address: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    device_model_id: deviceModelId.optional().nullable(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=Device.js.map